import { isDebugLogEnabled } from '@thoughtspot/logger';
import { getPDomDomain, isInDebugMode, isNebulaDevCluster, muzeChartPhase1Enabled, } from '@thoughtspot/session-service';
import React from 'react';
import { IFrameComponent } from '../components/iframe/iframe.component';
import { PDomComponent } from '../components/p-dom/p-dom.component';
import { ChartType } from '../types/prism';
import { SameOriginIframeComponent } from '../components/same-origin-iframe/same-origin-iframe.component';
import { shouldLoadChartInSameOrigin } from './use-chart-frame.util';
function getIframeComponent(componentId, viz, onLoad, onError) {
    const debug = (isInDebugMode() && isDebugLogEnabled()) || isNebulaDevCluster();
    const chartIframeElRef = React.useRef(null);
    const elementId = `chart-app-${componentId}`;
    const manifest = viz.config?.customChartManifest;
    let targetFrameUrl = '';
    if (manifest.sourceUrl) {
        targetFrameUrl = `${manifest.sourceUrl}${manifest?.chartAppAccessToken
            ? `?chartAppAccessToken=${manifest.chartAppAccessToken}`
            : ''}`;
    }
    return {
        chartIframeElRef,
        elementId,
        targetFrameUrl,
        chartJSX: (React.createElement(IFrameComponent, { elementId: elementId, customChartAppUrl: targetFrameUrl, chartIframeElRef: chartIframeElRef, onIFrameLoadCallback: onLoad, onIFrameErrorCallback: onError, extraData: {
                debug: String(debug),
                muzeChartPhase1Enabled: String(muzeChartPhase1Enabled())
            } })),
    };
}
export function chartTypeToSubdomain(chartType) {
    return chartType.toLowerCase().replace(/_/g, '-');
}
function getHostedChartComponent(componentId, viz, onLoad, onError, isPrintMode, isLiveboardContext) {
    const chartType = viz?.config?.chartType;
    const chartTypeLowerCase = String(chartType).toLowerCase();
    const shouldUseSameOrigin = shouldLoadChartInSameOrigin(chartType);
    const chartIframeElRef = React.useRef(null);
    const elementId = `hosted-chart-${componentId}`;
    const debug = (isInDebugMode() && isDebugLogEnabled());
    if (shouldUseSameOrigin) {
        const targetFrameUrl = `${window.location.origin}?chartType=${chartTypeLowerCase}`;
        return {
            chartIframeElRef,
            elementId,
            targetFrameUrl,
            chartJSX: (React.createElement(SameOriginIframeComponent, { elementId: elementId, chartType: viz.config.chartType, chartIframeElRef: chartIframeElRef, onIFrameLoad: onLoad, onIFrameError: onError, debug: debug, extraData: {
                    debug: String(debug),
                    muzeChartPhase1Enabled: String(muzeChartPhase1Enabled()),
                    chartType: chartTypeLowerCase
                } })),
        };
    }
    const domainSuffix = getPDomDomain();
    const targetFrameUrl = isLiveboardContext ?
        `https://hc-${chartTypeToSubdomain(String(chartType))}.${domainSuffix}` :
        `https://hc-advanced.${domainSuffix}?chartType=${chartTypeLowerCase}`;
    return {
        chartIframeElRef,
        elementId,
        targetFrameUrl,
        chartJSX: (React.createElement(PDomComponent, { chartIframeElRef: chartIframeElRef, elementId: elementId, targetFrameUrl: targetFrameUrl, chartType: viz.config.chartType, disableOriginAgentCluster: !!isPrintMode, onLoad: onLoad, onError: onError, extraData: {
                debug: String(debug),
                muzeChartPhase1Enabled: String(muzeChartPhase1Enabled()),
                chartType: chartTypeLowerCase
            } })),
    };
}
export const useChartFrame = (componentId, viz, onLoad, onError, isPrintMode, isLiveboardContext) => {
    if (viz.config.chartType === ChartType.CustomChart) {
        return getIframeComponent(componentId, viz, onLoad, onError);
    }
    return getHostedChartComponent(componentId, viz, onLoad, onError, isPrintMode, isLiveboardContext);
};
//# sourceMappingURL=use-chart-frame.js.map